import { z } from 'zod';
import { KIPIVERSE_INQUIRY_STATUS } from '@/utils/constants';

export const updateKipiverseInquiryStatusSchema = z.object({
  status: z.nativeEnum(KIPIVERSE_INQUIRY_STATUS, {
    required_error: 'Status is required',
  }),
});

export type UpdateKipiverseInquiryStatusFormValues = z.infer<typeof updateKipiverseInquiryStatusSchema>;
